<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Emblem of Faith Untouched</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="intro"><a id="page_1"></a><a href="#/xhtml/contents#intro"><i>Introduction</i></a></p>
<p class="BodyFlush"><i><span class="dropcap">E</span>mblem of Faith Untouched</i> is a biography written for those interested in Thomas Cranmer and the English Reformation, but who are not professional scholars in the field. Diarmaid MacCulloch’s brilliant and in-depth study, <i>Thomas Cranmer,</i> provides a compendium of information about Cranmer, addressing scholars’ contradictions about Cranmer’s life, motives, and personality, as well as his effect on the development of the Anglican Church. I am deeply indebted to MacCulloch for providing such a comprehensive and factual study.</p>
<p class="Body">This book is a text for seminarians, priests, and lay students of English history and theology, and of the development of the Anglican/Episcopal Church. Though the book includes the theology and history of the period, it is primarily anecdotal in focus, telling the stories of Cranmer’s life. Originally based on John Foxe’s narrative in <i>Acts and Monuments</i>, this current Cranmer biography tends to view Cranmer’s martyrdom from the Anglican perspective, but includes information from all the other major biographical sources, including the Roman Catholic view, thus making Thomas Cranmer as human and real as possible.</p>
<p class="Body">For a smoother read, all quotations, ideas, events, dates, and facts are documented in the back.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?be133190